function parseMaybeJson(value) {
  if (typeof value !== "string") return value;
  const trimmed = value.trim();
  if (!trimmed || (trimmed[0] !== "{" && trimmed[0] !== "[")) return value;
  try {
    return JSON.parse(trimmed);
  } catch {
    return value;
  }
}

function extractMessage(source, depth = 0) {
  if (source == null || depth > 4) return null;

  const obj = parseMaybeJson(source);
  if (typeof obj === "string") {
    const text = obj.trim();
    return text || null;
  }
  if (typeof obj !== "object") return null;

  const keys = [
    "message",
    "msg",
    "response_message",
    "responseMessage",
    "status_message",
    "statusMessage",
    "description",
    "detail",
    "error_message",
    "errorMessage",
  ];

  for (const key of keys) {
    const value = obj[key];
    if (typeof value === "string" && value.trim()) return value.trim();
  }

  if (obj.data != null) {
    const nested = extractMessage(obj.data, depth + 1);
    if (nested) return nested;
  }

  const firstError = obj.errors?.[0];
  if (firstError?.message) {
    const parsed = parseMaybeJson(firstError.message);
    if (typeof parsed === "object" && parsed?.message) {
      return String(parsed.message).trim();
    }
    if (typeof parsed === "string" && parsed.trim()) return parsed.trim();
    return String(firstError.message).trim();
  }

  return null;
}

export function getApiMessage(source, fallback = "Something went wrong") {
  return extractMessage(source) || fallback;
}

export function getApiSuccessMessage(source) {
  return extractMessage(source) || "";
}

export function extractItems(parsed) {
  const data = parsed?.data;
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.items)) return data.items;
  return [];
}

export function isSuccess(parsed) {
  return parsed?.status === "SUCCESS";
}
